import { TOGGLER_SIDEBAR } from "./types/themeTypes";

export const setToggler = () => ({
  type: TOGGLER_SIDEBAR
});
